import React from 'react';
import type { ComponentProps } from 'react';
import styled from '@emotion/styled';
import type { BorderRadiusProps, HeightProps, WidthProps } from 'styled-system';
import { borderRadius, height, width } from 'styled-system';

import type { ButtonKind } from 'common/components/Button';
import { ButtonLink } from 'common/components/Button';
import { SubtitleST3 } from 'common/components/Typography';
import type { SpaceProps } from 'common/theme/system-types';
import type { TeaserProps } from '../types';

type TeaserCtaButtonProps = {
  ctaButtonLabel?: TeaserProps['ctaButtonLabel'];
  ctaButtonType?: TeaserProps['ctaButtonType'];
  ctaButtonUrl?: TeaserProps['ctaButtonUrl'];
  ctaButtonAriaLabel?: TeaserProps['ctaButtonAriaLabel'];
  onClick?: () => void;
};

const InnerTeaserCtaButton = styled(ButtonLink)<
  SpaceProps & WidthProps & HeightProps & BorderRadiusProps
>`
  ${width};
  ${height};
  ${borderRadius};
`;

const innerTeaserCtaButtonStyles: Partial<ComponentProps<typeof InnerTeaserCtaButton>> = {
  px: 'sp_12',
  py: 'sp_8',
  m: 'sp_2',
  height: '40px',
  boxShadow: 'none',
  width: 'fit-content',
  borderRadius: 'x-large',
};

const TeaserCtaButton = ({
  ctaButtonLabel,
  ctaButtonType,
  ctaButtonUrl,
  ctaButtonAriaLabel,
  onClick,
}: TeaserCtaButtonProps) => {
  if (!ctaButtonLabel || !ctaButtonUrl) return null;

  const handleClick = () => {
    if (onClick) {
      onClick();
    }
  };

  return (
    <InnerTeaserCtaButton
      {...innerTeaserCtaButtonStyles}
      href={ctaButtonUrl.url || ''}
      {...(ctaButtonAriaLabel ? { ['aria-label']: ctaButtonAriaLabel } : {})}
      {...(ctaButtonType ? { kind: ctaButtonType as ButtonKind } : {})}
      onClick={handleClick}
    >
      <SubtitleST3 as="span" color="inherit">
        {ctaButtonLabel}
      </SubtitleST3>
    </InnerTeaserCtaButton>
  );
};

export default TeaserCtaButton;
